import React, { useState, useEffect } from "react";
import UserStatsTableView from './UserStatsTableView';
import UserStatsAssignBy from "./UserStatsAssignBy";
import axios from "axios";

const UserStatsPage = () => {

     const [userList, setUserList] = useState([]);
           const [selectedUser, setSelectedUser] = useState('');

          
        
    
        useEffect(() => {
        axios.get("/api/users.php")
          .then(res => setUserList(res.data))
          .catch(err => console.error("Error fetching users", err));
      }, []);
  return (
    <div className="p-4 px-2">
        <div className="flex  pl-8">
            <select
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
                className="px-2 py-1 rounded-md text-sm border border-gray-300 shadow-sm focus:ring bg-white focus:ring-blue-200"
              >
                <option>Select User</option>
                {userList.map((u) => (
                  <option key={u.id} value={u.name}>{u.name}</option>
                ))}
            </select>
              
        </div>

            
        <UserStatsTableView  selectedUser={selectedUser} />
        <UserStatsAssignBy selectedUser={selectedUser}/>
    </div>
    
  )
}

export default UserStatsPage